import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { Col, Container, Row } from 'react-bootstrap';
import { ReactComponent as Logo } from '../../assets/cg-icon-globe.svg';

export interface AccessDeniedProps {
  requiredRoles?: string[];
  message?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({
  requiredRoles,
  message
}) => {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/');
  };

  const handleSwitchAccount = async () => {
    try {
      await auth.signinRedirect({
        prompt: 'login',
        extraQueryParams: { prompt: 'login' },
        state: { returnUrl: window.location.pathname + window.location.search }
      });
    } catch (error) {
      console.error('Switch account error:', error);
      await auth.removeUser();
      await auth.clearStaleState();
      await auth.signinRedirect({
        prompt: 'login',
        extraQueryParams: { prompt: 'login' },
        state: { returnUrl: window.location.pathname + window.location.search }
      });
    }
  };

  const handleSignOut = async () => {
    try {
      await auth.signoutRedirect();
    } catch (error) {
      console.error('Sign out error:', error);
      await auth.removeUser();
      await auth.clearStaleState();
      window.location.href = '/';
    }
  };

  return (
    <div className={'mask'}>
      <Container>
        <Row>
          <Col className={'text-center'}>
            <Logo style={{ width: 100, height: 100 }} />
            <h1 className={'mt-3'}>Access Denied</h1>
            <p className={'text-muted mb-4'}>
              {message ||
                `You do not have permission to access the Facilitator portal.`}
            </p>
            <div className={'d-flex justify-content-center gap-2 flex-wrap'}>
              <Button
                themeColor={'primary'}
                className={'me-1'}
                onClick={handleReturnHome}>
                Return to Home
              </Button>
              <Button
                themeColor={'warning'}
                className={'me-1'}
                onClick={handleSwitchAccount}>
                Switch Account
              </Button>
              <Button
                themeColor={'secondary'}
                className={'me-1'}
                onClick={handleSignOut}>
                Sign Out
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AccessDenied;
